/**
 * English catalog — canonical merged message map.
 *
 * Imports every namespace and flattens them into one namespace-prefixed lookup
 * (`nav.dashboard`, `common.retry`). This module is the SINGLE SOURCE OF TRUTH for
 * the app's key set: `MessageKey` is derived from it, so `ko/index.ts`, the core
 * translator, and every `t('<ns>.<key>')` call are all type-checked against these
 * keys. Adding a namespace here (and in `ko/index.ts`) is the only place the index
 * changes; individual namespace files are edited freely without touching this file
 * beyond registering a brand-new namespace.
 */
import { flatten } from "../flatten";
import { common } from "./common";
import { nav } from "./nav";
import { auth } from "./auth";
import { settings } from "./settings";
import { dashboard } from "./dashboard";
import { market } from "./market";
import { portfolio } from "./portfolio";
import { strategies } from "./strategies";
import { strategiesDetail } from "./strategiesDetail";
import { orders } from "./orders";
import { approvals } from "./approvals";
import { notifications } from "./notifications";
import { chat } from "./chat";
import { backtest } from "./backtest";
import { mobile } from "./mobile";

const namespaces = {
  common,
  nav,
  auth,
  settings,
  dashboard,
  market,
  portfolio,
  strategies,
  strategiesDetail,
  orders,
  approvals,
  notifications,
  chat,
  backtest,
  mobile,
} as const;

/** The flat English message map keyed by `<namespace>.<localKey>`. */
export const en = flatten(namespaces);

/** Every valid message key. All translator APIs are typed against this union. */
export type MessageKey = keyof typeof en;
